// constants.js
import {
    SET_CHECK_IND,
    UPDATE_CHECK_IND_ITEM
} from "../constants/index";

// reducer
const initialValue = {
    checkInd: []  // array of games
}

const checkIndReducer = (state = initialValue, action) => {
    switch(action.type) {
        case SET_CHECK_IND:
            return {
                ...state,
                checkInd: action.data  // set entire array
            };
        // case UPDATE_CHECK_IND_ITEM:
        //     // action.data = { CheckId, newData }
        //     return {
        //         ...state,
        //         checkInd: state.checkInd.map((gameArray) =>
        //             gameArray.map(item =>
        //                 item.CheckId === action.data.CheckId
        //                     ? { ...item, ...action.data.newData }
        //                     : item
        //             )
        //         )
        //     };
        default:
            return state;
    }
}

export default checkIndReducer;
